var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9307 12.8057C17.5753 12.161 17.9375 11.2867 17.9375 10.375C17.9375 9.46332 17.5753 8.58898 16.9307 7.94432C16.286 7.29966 15.4117 6.9375 14.5 6.9375C13.5883 6.9375 12.714 7.29966 12.0693 7.94432C11.4247 8.58898 11.0625 9.46332 11.0625 10.375C11.0625 11.2867 11.4247 12.161 12.0693 12.8057C12.714 13.4503 13.5883 13.8125 14.5 13.8125C15.4117 13.8125 16.286 13.4503 16.9307 12.8057Z",
    stroke: "#262F5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 10.375V3.39963C28.25 2.61863 27.8045 1.91188 27.0579 1.68088C25.7612 1.27663 23.4086 0.75 20 0.75C13.7025 0.75 12.0209 3.05587 3.33225 1.333C2.01638 1.07175 0.75 2.04938 0.75 3.39V17.1634C0.75 18.1094 1.40037 18.9413 2.32437 19.1448C7.66625 20.3231 10.5152 20.0715 13.125 19.6191",
    stroke: "#262F5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.25C3.43262 6.25 5.84437 4.05688 6.15237 1.78675M23.4375 1.4375C23.4375 4.2425 25.8644 6.89487 28.25 6.89487M6.25 19.307C6.25 17.8483 5.67054 16.4494 4.63909 15.4179C3.60764 14.3865 2.20869 13.807 0.75 13.807M17.25 20C17.25 20 18.625 20 20 22.75C20 22.75 24.3684 15.875 28.25 14.5",
    stroke: "#262F5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpay);
export default __webpack_public_path__ + "static/media/epay.3a4f640a5cbeddf93c4ef7c16ca7e8b8.svg";
export { ForwardRef as ReactComponent };